var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModevisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#888888",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm.1-83.87q-40.01 0-68.12-28.01-28.11-28.01-28.11-68.02 0-40.01 28.01-68.12 28.01-28.11 68.02-28.11 40.01 0 68.12 28.01 28.11 28.01 28.11 68.02 0 40.01-28.01 68.12-28.01 28.11-68.02 28.11Zm-.1 221.39q-152.78 0-277.02-87.15Q78.74-356.78 22.48-500q56.26-143.22 180.5-230.37Q327.22-817.52 480-817.52q152.78 0 277.02 87.15Q881.26-643.22 937.52-500q-56.26 143.22-180.5 230.37Q632.78-182.48 480-182.48ZM480-500Zm.05 220q112.38 0 206.32-59.78Q780.3-399.57 830.3-500q-50-100.43-143.98-160.22Q592.33-720 479.95-720q-112.38 0-206.32 59.78Q179.7-600.43 129.7-500q50 100.43 143.98 160.22Q367.67-280 480.05-280Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModevisibility);
export default __webpack_public_path__ + "static/media/modevisibility.96ab44570271a4e4633cc9044597d7ac.svg";
export { ForwardRef as ReactComponent };